export const UPDATE_HEALTH: string = "UpdateHealth";
export const UPDATE_PROGRESS: string = "UpdateProgress";
export const ON_DEBUG_BALLOON_PARAM_CHANGED: string = "OnDebugBalloonParamChanged";
export const SHOW_DEBUG: string = "ShowDebug";
export const HIDE_DEBUG: string = "HideDebug";
export const HEALTH_DEPLETED: string = "HealthDepleted";
export const LEVEL_COMPLETED: string = "LevelCompleted";
export const SPEED_BOOST_START: string = "SpeedBoostStart";
export const SPEED_BOOST_END: string = "SpeedBoostEnd";
export const SPAWN_PROJECTILE: string = "SpawnProjectile";
export const BALLOON_LIFT_START: string = "BalloonLiftStart";
export const BALLOON_LIFT_END: string = "BalloonLiftEnd";
export const CHECKPOINT_REACHED: string = "CheckpointReached";
export const TICKET_COLLECTED: string = "TicketCollected";
export const SHOW_ONBOARDING_ARROW: string = "ShowOnboardingArrow";
export const HIDE_ONBOARDING_ARROW: string = "HideOnboardingArrow";
export const SHOW_ONBOARDING_KEYBOARD: string = "ShowOnboardingKeyboard";
export const HIDE_ONBOARDING_KEYBOARD: string = "HideOnboardingKeyboard";
export const FLASH_HEALTH_BAR: string = "FlashHealthBar";
export const KEYBOARD_FOCUS_BEGIN: string = "KeyboardFocusBegin";
export const KEYBOARD_FOCUS_END: string = "KeyboardFocusEnd";
export const KEYBOARD_REFOCUS: string = "KeyboardRefocus";
export const CHECK_POWERUP_OVERLAP: string = "CheckPowerupOverlap";
export const PLAY_CAPTION: string = "PlayCaption";
export const STOP_CAPTION: string = "StopCaption";
export const STOP_POWERUPS: string = "StopPowerups";
export const RESUME_POWERUPS: string = "ResumePowerups";
